import { DayPicker } from 'react-day-picker'
import { es, fr } from 'react-day-picker/locale'
import { useTranslation } from 'react-i18next'
import * as S from '@/components/global/Calendar/Calendar.styled'
import { CalendarNavigation } from '@/components/global/Calendar/CalendarNavigation'
import { zLayers } from '@/utils/styling/zLayers'
import { LOCALE_MAP } from '@messenger/consts'

export const Calendar = ({
  date: [date, setDate] = [null, () => {}],
  show: [, setShow] = [null, () => {}],
  disabledDays,
}) => {
  const { i18n } = useTranslation()

  const mapI18nCodeToDayPickerLocale = (languageCode) => {
    const englishIsDefaultNoLocaleNecessary = undefined

    switch (languageCode) {
      case LOCALE_MAP.ES:
        return es
      case LOCALE_MAP.FR:
        return fr
      case LOCALE_MAP.EN:
      default:
        return englishIsDefaultNoLocaleNecessary
    }
  }
  const currentLocale = mapI18nCodeToDayPickerLocale(i18n.language)

  const handleSelection = (day) => {
    if (!day) {
      setShow(false)
      return
    }
    if (!date || day?.getTime() !== date?.getTime()) {
      setDate(day)
      setShow(false)
    }
  }

  return (
    <S.Calendar zindex={zLayers.base}>
      <DayPicker
        mode="single"
        month={date}
        onMonthChange={setDate}
        selected={date}
        onSelect={handleSelection}
        disabled={disabledDays}
        defaultMonth={date || new Date()}
        locale={currentLocale}
        components={{
          Nav: CalendarNavigation,
        }}
      />
    </S.Calendar>
  )
}

export default Calendar
